// extracted by mini-css-extract-plugin
export default {"InfoBoxClipboard":"_InfoBoxClipboard--Dxsai","InfoBoxValue":"_InfoBoxValue--qLrUD","CopyButton":"_CopyButton--uBqFz","CopyCheck":"_CopyCheck--ujrD4"};